'use strict';

module.exports = [
    {
        level: '1',
        code: 'M',
        label: 'Married',
        description: 'A current marriage contract is active'
    },
    {
        level: '2',
        code: 'D',
        label: 'Divorced',
        description:
            'Marriage contract has been declared dissolved and inactive'
    },
    {
        level: '3',
        code: 'W',
        label: 'Widowed',
        description: 'The spouse has died.'
    },
    {
        level: '4',
        code: 'S',
        label: 'Never Married',
        description: 'No marriage contract has ever been entered'
    },
    {
        level: '5',
        code: 'T',
        label: 'Domestic partner',
        description:
            'Person declares that a domestic partner relationship exists.'
    },
    {
        level: '6',
        code: 'UNK',
        label: 'Unknown',
        description: 'A proper value is applicable, but not known...'
    }
];
